import React from 'react';
import { forwardRef } from '@hover/blueprint/chakra';
import { Button, ButtonProps, dArrowUpRight } from '@hover/blueprint/brand';

export interface ArrowButtonProps extends ButtonProps {}

const ArrowButton = forwardRef<ArrowButtonProps, 'button'>((props, ref) => (
  <Button {...props} decorationAfter={dArrowUpRight} ref={ref} />
));

export default ArrowButton;
